module.exports = __webpack_public_path__ + "static/media/viva_garden_01_B.a44f3ad8.png";